<script>
  import { createEventDispatcher } from "svelte"
  import { db, auth, fstore } from "../etc/firebase.js"
  import {
    guaRecordStore,
    userGuaCount,
    selectedLanguage,
  } from "../etc/store.js"
  import YinYao from "../utils/YinYao.svelte"
  import YangYao from "../utils/YangYao.svelte"
  import GuaResult from "../utils/GuaResult.svelte"
  import ShowGuaText from "../utils/ShowGuaText.svelte"
  import marked from "marked"
  import ShowCompleteYaoInfo from "../utils/ShowCompleteYaoInfo.svelte"
  import AesCtr from "../etc/aes-ctr.js"

  import {
    scrollToId,
    categories,
    formatDate,
    buildComment,
    guaCommentsToString,
    buildYaoColorArray,
    number2code,
    findGua,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    reverseString,
    btn_style_blue_d2,
    btn_style_red_d2,
    btn_style_purple_d2,
    btn_style_cyan_d2,
    btn_style_light_blue_a3,
    btn_style_teal,
    btn_style_orange_d2,
    btn_style_indigo_l1,
    btn_style_yellow_d3,
    btn_style_red_l3,
    btn_style_lime_d3,
    xiyiSalt,
  } from "../etc/helpers.js"

  export let id = ""
  export let record = {}

  //export let reloadGuaRecordsFromDB
  //console.log("@ Record: Got salt: ", xiyiSalt)

  const dispatch = createEventDispatcher()

  function sayHello() {
    dispatch("message", {
      text: "Hello!",
    })
  }

  let sectionName = "Record"
  let numStr = ""
  let gua_code = ""
  let reversed_code = ""
  let guaName = ""
  $: numStr = record.guaNumbers
  let changingYao = checkChanging(numStr)
  let movingYaos = getMovingYaoPositions(numStr)
  let movingYaoArray = getMovingYaoPositions(numStr).split(",")
  $: gua_code = number2code(record.guaNumbers)
  $: reversed_code = reverseString(gua_code)
  $: guaName = findGua(gua_code)

  //console.log("In Record, id = ", id)
  //console.log("In Record, record.guaNumbers = ", record.guaNumbers)
  // console.log("In Record, gua_code = ", gua_code)

  let yaoColor = []
  $: yaoColor = buildYaoColorArray(numStr)
  let lastYao = []

  let new_category = record.category
  let new_tags = []
  let currentTagArray = []
  let catChanged = false

  $: new_category != record.category
    ? (catChanged = true)
    : (catChanged = false)

  let guaDeleted = false

  // Update guaRecordStore (localStorage)
  function updateGuaRecordStore(firebaseUid) {
    // console.log("@ Record: Updatng GuaRecordStore for UID: " + firebaseUid)

    let guaRecords = []
    let guaCount = 0
    db.collection("guaRecords")
      .where("firebaseUid", "==", firebaseUid)
      .get()
      .then((querySnapshot) => {
        guaCount = 0
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          guaCount++
          let tmpArray = doc.data()
          tmpArray.show = true
          tmpArray.id = doc.id
          guaRecords.push(tmpArray)
        })
        // sort the guaRecords per recordDT as default sort.
        //  console.log("@ Record: before sort guaRecords = ", guaRecords)
        guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
        //  console.log("@ Record: after sort guaRecords = ", guaRecords)

        // currentUserGuaCount.set(guaCount)
        // $userStore.guaCount = guaCount
        // $userStore.guaRecords = [...guaRecords]
        $guaRecordStore = JSON.stringify(guaRecords)
        $userGuaCount = guaCount
        // console.log(
        //   "@ Record: guaCount in $userGuaCount is updated = " + $userGuaCount
        // )
        // console.log(
        //   "@ Record: $userStore.guaRecords = ",
        //   $userStore.guaRecords
        // )
        // console.log(
        //   "@ Record: +++ the refreshed JSON.parse($guaRecordStore) = ",
        //   JSON.parse($guaRecordStore)
        // )
        showSummary = false
      })
      .catch(function (error) {
        console.log("@ Record: Error getting guaRecords documents: ", error)
      })
  }

  //function
  const deleteGuaRecord = () => {
    if (confirm("請確認：您確定要永久移除這個卦例嗎?")) {
      db.collection("guaRecords")
        .doc(id)
        .delete()
        .then(() => {
          //console.log("Document successfully deleted!")
          updateGuaRecordStore(record.firebaseUid)
          alert("卦例已移除！")
          // location.reload()
          showSummary = false
          guaDeleted = true
          //sayHello()
        })
    } else {
      // alert("取消移除卦例。")

      showSummary = false
      guaDeleted = false
    }
  }

  // The follow code is for DOM ops
  let showSummary = false
  let showDetails = false
  //console.log("record.qiGuaDT type is ->")
  //console.log(typeof record.qiGuaDT)

  function showView(view) {
    showSummary = false
    showDetails = false

    // console.log("@ Record: showView option: " + view)

    if (view == "details") {
      showDetails = true
    } else {
      showSummary = true
    }
  }

  function handleShowSummary() {
    let x = document.getElementById("guas-filter")
    x.style.display = "block"

    if (showSummary) {
      showSummary = false
    } else {
      showView("summary")
    }
  }

  function handleShowDetails() {
    let x = document.getElementById("guas-filter")
    x.style.display = "none"

    showView("details")
  }

  // Comment section
  let showInputField = false
  let newComment = ""
  function showAddCommentField() {
    showInputField = true
    newComment = ""
  }

  function addComment() {
    let dt = new Date(Date.now()).toString()

    // console.log("@ Record: adding comment")
    db.collection("guaRecords")
      .doc(id)
      .update({
        // comment: fstore.FieldValue.arrayUnion(buildComment(dt, newComment)),
        encryptionOn: true,
        comment: fstore.FieldValue.arrayUnion({
          dt: dt,
          content: AesCtr.encrypt(newComment, xiyiSalt, 256),
        }),
      })
      .then(() => {
        updateGuaRecordStore(record.firebaseUid)
        // location.reload()
        // console.log("@ Record: Comment is updated.")
      })

    showInputField = false
  }

  const cancelComment = () => {
    showInputField = false
  }

  // Explanation section
  let showExplainField = false
  let newExplanation = ""
  function showAddExlpainField() {
    // need to get the string between <my_explanation> and </my_explanation>
    // Step 1: get rid of '/' in the string
    // Step 2: split with "<my_explanation>"
    // Step 3: the last item in the splitted array is the original explanation

    // let tmpString = record.explanation
    // let tmpString = decryptText(record.explanation.content)

    // console.log(
    //   "@ Record.showAddExplanation, got existing explanation = " +
    //     record.explanation
    // )
    // console.log(
    //   "@ Record.showAddExplanation, decrypted and got initial tmpString = " +
    //     tmpString
    // )
    // tmpString = tmpString.replace(/\//g, "")
    // let tmpArray = tmpString.split("<my_explanation>")
    // showExplainField = true
    // newExplanation = tmpArray[tmpArray.length - 2]

    if (record.explanation == undefined) {
      newExplanation = ""
    } else {
      //  console.log (
      //     "@ Record.showAddExplanation, got existing explanation obj = ",
      //     record.explanation
      //   )

      newExplanation = decryptText(record.explanation.content)
    }

    // console.log(
    //   "@Record.showAddExplainField: newExplanation = ",
    //   newExplanation
    // )

    showExplainField = true
  }

  function addExplanation() {
    let dt = new Date(Date.now()).toString()
    // let updatedExplanation =
    //   "<hr/><strong>更新日期：</strong>" +
    //   dt +
    //   "<br/><strong>解卦如下：</strong><br/><my_explanation>" +
    //   newExplanation +
    //   "</my_explanation>"

    let updatedExplanation = {
      dt: dt,
      content: AesCtr.encrypt(newExplanation, xiyiSalt, 256),
    }

    // if (newExplanation.length > 0) {
    // console.log("@ Record: adding explanation")
    db.collection("guaRecords")
      .doc(id)
      .update({
        // explanation: updatedExplanation,
        encryptionOn: true,
        explanation: updatedExplanation,
      })
      .then(() => {
        updateGuaRecordStore(record.firebaseUid)
        // location.reload()
        //  console.log("@ Record: Explanation is updated.")
      })
    //  }
    showExplainField = false
  }

  const cancelExplanation = () => {
    showExplainField = false
  }

  let showEditCatsTags = false
  const handleShowEditCatsTags = () => {
    showEditCatsTags = !showEditCatsTags
    currentTagArray = [...record.tag]
    // console.log("--- Toggle EditCatsTags div ---")
  }

  function updateCatsTags() {
    // console.log("@ Record.updateCatsTags")

    let updatedDT = new Date().getTime()
    db.collection("guaRecords")
      .doc(id)
      .update({
        updatedDT: updatedDT,
        category: new_category,
        tag: tagAdded ? tagArray : record.tag,
      })
      .then(() => {
        updateGuaRecordStore(record.firebaseUid)
        showEditCatsTags = false
        // location.reload()
        //  console.log("@ Record: cats and tags are updated.")
      })
  }

  const cancelUpdateCatsTags = () => {
    new_category = ""
    new_tags = []
    showEditCatsTags = false
  }

  let new_tag
  let tagAdded = false
  let tagString = ""
  let tagArray = []

  // Need to add tag array to firestore
  function addTag() {
    //currentTagArray = record.tag
    tagString = record.tag.toString()
    new_tags.push(new_tag.toUpperCase())
    // remove all white space in the string before saving it to tagString
    if (tagString == "") {
      tagString = new_tags.toString().replace(/\s+/g, "")
    } else {
      tagString = tagString + "," + new_tags.toString().replace(/\s+/g, "")
    }

    tagArray = tagString.split(",")
    tagAdded = true

    // console.log("@ Record: a new tag added: " + new_tag)
    // console.log("@ Record: new_tags is now: " + new_tags.toString())
    // console.log("@ Record: new_tags length is: " + new_tags.length)
    // console.log("@ Record: tagString now is: " + tagString)
    // console.log("@ Record: tagArray  is: ", tagArray)

    new_tag = ""

    // scrollToId("update-btn-row")
  }

  // remove a tag
  function handleRemoveTag(tag) {
    // console.log("@ Record.handleRemoveTag: removing tag: " + tag)

    // show less buttons
    currentTagArray = currentTagArray.filter((item) => item !== tag)

    // update db
    let updatedDT = new Date().getTime()
    db.collection("guaRecords")
      .doc(id)
      .update({
        updatedDT: updatedDT,
        tag: currentTagArray,
      })
      .then(() => {
        updateGuaRecordStore(record.firebaseUid)
        // location.reload()
        // console.log(
        //   "@ Record.handleRemoveTag: just removed some tags and db is updated."
        // )
      })

    record.tag = [...currentTagArray]
  }

  function decryptText(encryptedText) {
    //console.log("@ Record.decryptText for record", record)
    //console.log("@ Record.decryptText for encryptedText", encryptedText)

    let decrypted_text = " "
    if (record.encryptionOn == true) {
      // console.log(
      //   "@ Record.decryptText for decrypted text is = ",
      //   AesCtr.decrypt(encryptedText, xiyiSalt, 256)
      // )

      decrypted_text = AesCtr.decrypt(encryptedText, xiyiSalt, 256)

      // console.log("@ Record.decryptText: got decrypted_text = ", decrypted_text)
      // console.log(
      //   "@ Record.decryptText: got decrypted_text typeof ",
      //   typeof decrypted_text
      // )
      return decrypted_text
      // return "<p>This is empty</p>"
    } else {
      return decrypted_text
    }
  }

  function buildHtmlExplanation(explanationObj) {
    let decrypted_explanation = decryptText(explanationObj.content)

    let htmlExplanation =
      "<strong>更新日期：</strong>" +
      explanationObj.dt +
      "<br/><strong>解卦如下：</strong><br/>" +
      decrypted_explanation

    // console.log(
    //   "@ Record.buildHtmlExplanation: htmlExplanation = ",
    //   htmlExplanation
    // )
    return htmlExplanation
  }
  // function handleReload() {
  //   reloadGuaRecordsFromDB = true
  // }
</script>

{#if $selectedLanguage == "TW"}
  <div class="record-row">
    <div class="title-row">
      <div on:click={handleShowSummary} class="guapic">
        <div class=" guacard">
          <div class="center blue lighten-5 guabox">
            <div class="gua-title">{findGua(gua_code)}</div>
            {#each reversed_code as digit, i}
              {#if digit == "0"}
                <YinYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} />
              {:else}
                <YangYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} />
              {/if}
            {/each}
          </div>
        </div>
        <div class="record-summary">
          起卦日期： {new Date(record.qiGuaDT)} <br />
          起卦人： {record.qiGuaPerson} <br />
          <!-- 問題： {record.question} <br /> -->
          問題： {decryptText(record.question)} <br />
          類別： {record.category} <br />
          標記： {record.tag} <br />
        </div>
      </div>
    </div>
  </div>
  <div class="card indigo lighten-5">
    <div
      class="card-body gua-results"
      style="display:{showSummary ? 'block' : 'none'}"
    >
      <button class={btn_style_teal} on:click={handleShowDetails}>細究</button>
      <button class={btn_style_indigo_l1} on:click={handleShowEditCatsTags}
        >調整類別標記</button
      >
      <button class={btn_style_purple_d2} on:click={() => showAddCommentField()}
        >筆記</button
      >
      <button
        class={btn_style_light_blue_a3}
        on:click={() => showAddExlpainField()}>解卦</button
      >
      <a class={btn_style_orange_d2} href="/qi">再占</a>

      <br />

      <div
        class="comment-input"
        style="display:{showInputField ? 'block' : 'none'}"
      >
        <div class="markdown-text">
          <label for="markdown">New Comment</label>
          <textarea
            class="white"
            bind:value={newComment}
            placeholder="Enter text here"
          />
        </div>
        <div class="btn-row">
          <button class={btn_style_blue_d2} on:click={addComment}
            >加入筆記</button
          >
          <button class={btn_style_red_d2} on:click={cancelComment}>取消</button
          >
        </div>
        <!-- Convert the markdown to HTML and display it -->

        <div class="preview">{@html marked(newComment)}</div>
      </div>
      <div
        class="explanation-input"
        style="display:{showExplainField ? 'block' : 'none'}"
      >
        <div class="markdown-text">
          <label for="markdown">試解卦</label>
          <textarea
            class="white"
            bind:value={newExplanation}
            placeholder="Enter text here"
          />
        </div>
        <div class="btn-row">
          <button class={btn_style_blue_d2} on:click={addExplanation}
            >輸入解卦</button
          >
          <button class={btn_style_red_d2} on:click={cancelExplanation}
            >取消</button
          >
        </div>
        <!-- Convert the markdown to HTML and display it -->

        <div class="preview">{@html marked(newComment)}</div>
      </div>

      <!-- Update Cats and tags -->
      <div
        class="edit-cats-tags"
        style="display:{showEditCatsTags ? 'block' : 'none'}"
      >
        <hr />
        <h6>更新類別與標記</h6>
        <label>目前選定類別： {record.category}</label>

        <div class="new-category">
          <label>請選擇更新類別： </label>
          {#each categories as item}
            <label>
              <input type="radio" bind:group={new_category} value={item} />
              <span class="checkbox-spacing">{item}</span>
            </label>
          {/each}
          <br /><span class="blue-text darken-2"
            ><strong>
              {new_category == ""
                ? ""
                : "選定的類別為 : " + new_category}</strong
            ></span
          >
        </div>
        <div class="tag-field">
          <label>您可以取消目前標記：</label>
          <div class="cancel-tag">
            {#each currentTagArray as tag}
              <button
                class={btn_style_red_l3 + " btn-small"}
                on:click={() => handleRemoveTag(tag)}>{"X " + tag}</button
              >
            {/each}
          </div>
          <label>您也可以加入額外標記(tags)，以便自己將來搜尋卦例：</label>
          <!-- <input type="hidden" bind:value={tag} /> -->
          <input type="text" bind:value={new_tag} />
          <button
            on:click|preventDefault={addTag}
            class={btn_style_lime_d3 + " btn-small"}>加入新標記</button
          >
          <span class="blue-text darken-2"
            ><strong>
              {tagAdded ? "已加入的額外標記： " + new_tags.toString() : ""}
            </strong></span
          >
          <br />
        </div>

        <div class="update-btn-row" id="update-btn-row">
          {#if catChanged == true || tagAdded == true}
            <br />
            <button
              class={btn_style_blue_d2 + " btn-large"}
              on:click={updateCatsTags}>更新類別與標記</button
            >
            <button
              class={btn_style_red_l3 + " btn-large"}
              on:click={cancelUpdateCatsTags}>取消更新</button
            >
          {/if}
        </div>
        <br /><br />
        <hr />
      </div>

      <!-- End update cats and tags -->
      <div class="gua-summary">
        登錄日期： {new Date(record.recordDT)} <br />
        登錄人：{record.recorder} <br />
        起卦日期： {new Date(record.qiGuaDT)} <br />
        起卦人： {record.qiGuaPerson} <br />
        卦源： {record.guaType} <br />
        卦名： {findGua(gua_code)} <br />
        問題： {decryptText(record.question)} <br />
        類別： {record.category} <br />
        標記： {record.tag} <br />
        <!-- 卦數： {record.guaNumbers} <br /> -->
        <!-- 卦碼： {gua_code} <br /> -->
        <!-- <GuaResult {numStr} /> -->
        {#if record.explanation == null}
          解卦： "" <br />
        {:else}
          <!-- 解卦： {@html marked(decryptText(record.explanation.content))} <br /> -->
          解卦：
          <div class="note-box light-green lighten-4">
            {@html marked(buildHtmlExplanation(record.explanation))}
          </div>
        {/if}
        {#if record.comment == null}
          筆記： "" <br />
        {:else}
          <!-- 筆記： {record.comment.content} <br /> -->
          <!-- 筆記： {@html marked(guaCommentsToString(record.comment))} <br /> -->
          <!-- Note: record.comment is an Array and will be passed to guaCommentsToString in helpers 
        to decrypt content and create the long HTML string. -->
          筆記：
          <div class="note-box blue lighten-5">
            {@html guaCommentsToString(record.comment)}
          </div>
        {/if}
        <br />
        <button class={btn_style_blue_d2} on:click={handleShowSummary}
          >關閉摘要</button
        >
        <button class={btn_style_red_d2 + " right"} on:click={deleteGuaRecord}
          >移除卦例</button
        >
      </div>
    </div>
  </div>

  <!-- Gua Detail Research Section Begin -->
  <div class="details " style="display:{showDetails ? 'block' : 'none'}">
    <div class="card indigo lighten-5">
      <div class="card-body ">
        <div class="gua-header">
          <h4>
            {guaName} 細究
            <div class="btn-group right">
              <!-- {#if sectionName != "qi"}
              <button class={btn_style_blue_d2} on:click={showYiOptions}
                >回易經選項</button
              >
            {/if} -->
              <button
                class={btn_style_blue_d2}
                on:click={() => showView("summary")}>回到摘要</button
              >
              <button
                class={btn_style_purple_d2}
                on:click={() => showAddCommentField()}>筆記</button
              >
              <button
                class={btn_style_light_blue_a3}
                on:click={() => showAddExlpainField()}>解卦</button
              >
            </div>
          </h4>

          <h5>問：{AesCtr.decrypt(record.question, xiyiSalt, 256)}</h5>
          <div
            class="comment-input"
            style="display:{showInputField ? 'block' : 'none'}"
          >
            <div class="markdown-text">
              <label for="markdown">New Comment</label>
              <textarea
                class="white"
                bind:value={newComment}
                placeholder="Enter text here"
              />
            </div>
            <div class="btn-row">
              <button class={btn_style_blue_d2} on:click={addComment}
                >加入筆記</button
              >
              <button class={btn_style_red_d2} on:click={cancelComment}
                >取消</button
              >
            </div>
            <!-- Convert the markdown to HTML and display it -->
            <hr />
            <div class="preview">{@html marked(newComment)}</div>
          </div>

          <div
            class="explanation-input"
            style="display:{showExplainField ? 'block' : 'none'}"
          >
            <div class="markdown-text">
              <label for="markdown">試解卦</label>
              <textarea class="white" bind:value={newExplanation} />
            </div>
            <button class={btn_style_blue_d2} on:click={addExplanation}
              >輸入解卦</button
            >
            <button class={btn_style_red_d2} on:click={cancelExplanation}
              >取消</button
            >

            <!-- Convert the markdown to HTML and display it -->

            <div class="preview">{@html marked(newComment)}</div>
          </div>
        </div>
        <div class="gua-text green lighten-5">
          <ShowGuaText numStr={reverseString(record.guaNumbers)} {gua_code} />
        </div>
        <div class="yao-level ">
          <ShowCompleteYaoInfo
            numStr={record.guaNumbers}
            {gua_code}
            incomingYaoColor={yaoColor}
            {sectionName}
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Gua Detail Research Section End -->
{:else}
  <div class="record-row">
    <div class="title-row">
      <div on:click={handleShowSummary} class="guapic">
        <div class=" guacard">
          <div class="center blue lighten-5 guabox">
            <div class="gua-title">{findGua(gua_code)}</div>
            {#each reversed_code as digit, i}
              {#if digit == "0"}
                <YinYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} />
              {:else}
                <YangYao yaoColor={yaoColor[i]} lastYao={lastYao[i]} />
              {/if}
            {/each}
          </div>
        </div>
        <div class="record-summary">
          起卦日期： {new Date(record.qiGuaDT)} <br />
          起卦人： {record.qiGuaPerson} <br />
          <!-- 问题： {record.question} <br /> -->
          问题： {decryptText(record.question)} <br />
          类别： {record.category} <br />
          标记： {record.tag} <br />
        </div>
      </div>
    </div>
  </div>
  <div class="card indigo lighten-5">
    <div
      class="card-body gua-results"
      style="display:{showSummary ? 'block' : 'none'}"
    >
      <button class={btn_style_teal} on:click={handleShowDetails}>细究</button>
      <button class={btn_style_indigo_l1} on:click={handleShowEditCatsTags}
        >调整类别标记</button
      >
      <button class={btn_style_purple_d2} on:click={() => showAddCommentField()}
        >笔记</button
      >
      <button
        class={btn_style_light_blue_a3}
        on:click={() => showAddExlpainField()}>解卦</button
      >
      <a class={btn_style_orange_d2} href="/qi">再占</a>

      <br />

      <div
        class="comment-input"
        style="display:{showInputField ? 'block' : 'none'}"
      >
        <div class="markdown-text">
          <label for="markdown">New Comment</label>
          <textarea
            class="white"
            bind:value={newComment}
            placeholder="Enter text here"
          />
        </div>
        <div class="btn-row">
          <button class={btn_style_blue_d2} on:click={addComment}
            >加入笔记</button
          >
          <button class={btn_style_red_d2} on:click={cancelComment}>取消</button
          >
        </div>
        <!-- Convert the markdown to HTML and display it -->

        <div class="preview">{@html marked(newComment)}</div>
      </div>
      <div
        class="explanation-input"
        style="display:{showExplainField ? 'block' : 'none'}"
      >
        <div class="markdown-text">
          <label for="markdown">试解卦</label>
          <textarea
            class="white"
            bind:value={newExplanation}
            placeholder="Enter text here"
          />
        </div>
        <div class="btn-row">
          <button class={btn_style_blue_d2} on:click={addExplanation}
            >输入解卦</button
          >
          <button class={btn_style_red_d2} on:click={cancelExplanation}
            >取消</button
          >
        </div>
        <!-- Convert the markdown to HTML and display it -->

        <div class="preview">{@html marked(newComment)}</div>
      </div>

      <!-- Update Cats and tags -->
      <div
        class="edit-cats-tags"
        style="display:{showEditCatsTags ? 'block' : 'none'}"
      >
        <hr />
        <h6>更新类别与标记</h6>
        <label>目前选定类别： {record.category}</label>

        <div class="new-category">
          <label>请选择更新类别： </label>
          {#each categories as item}
            <label>
              <input type="radio" bind:group={new_category} value={item} />
              <span class="checkbox-spacing">{item}</span>
            </label>
          {/each}
          <br /><span class="blue-text darken-2"
            ><strong>
              {new_category == ""
                ? ""
                : "选定的类别为 : " + new_category}</strong
            ></span
          >
        </div>
        <div class="tag-field">
          <label>您可以取消目前标记：</label>
          <div class="cancel-tag">
            {#each currentTagArray as tag}
              <button
                class={btn_style_red_l3 + " btn-small"}
                on:click={() => handleRemoveTag(tag)}>{"X " + tag}</button
              >
            {/each}
          </div>
          <label>您也可以加入额外标记(tags)，以便自己将来搜寻卦例：</label>
          <!-- <input type="hidden" bind:value={tag} /> -->
          <input type="text" bind:value={new_tag} />
          <button
            on:click|preventDefault={addTag}
            class={btn_style_lime_d3 + " btn-small"}>加入新标记</button
          >
          <span class="blue-text darken-2"
            ><strong>
              {tagAdded ? "已加入的额外标记： " + new_tags.toString() : ""}
            </strong></span
          >
          <br />
        </div>

        <div class="update-btn-row" id="update-btn-row">
          {#if catChanged == true || tagAdded == true}
            <br />
            <button
              class={btn_style_blue_d2 + " btn-large"}
              on:click={updateCatsTags}>更新类别与标记</button
            >
            <button
              class={btn_style_red_l3 + " btn-large"}
              on:click={cancelUpdateCatsTags}>取消更新</button
            >
          {/if}
        </div>
        <br /><br />
        <hr />
      </div>

      <!-- End update cats and tags -->
      <div class="gua-summary">
        登录日期： {new Date(record.recordDT)} <br />
        登录人：{record.recorder} <br />
        起卦日期： {new Date(record.qiGuaDT)} <br />
        起卦人： {record.qiGuaPerson} <br />
        卦源： {record.guaType} <br />
        卦名： {findGua(gua_code)} <br />
        问题： {decryptText(record.question)} <br />
        类别： {record.category} <br />
        标记： {record.tag} <br />
        <!-- 卦数： {record.guaNumbers} <br /> -->
        <!-- 卦码： {gua_code} <br /> -->
        <!-- <GuaResult {numStr} /> -->
        {#if record.explanation == null}
          解卦： "" <br />
        {:else}
          <!-- 解卦： {@html marked(decryptText(record.explanation.content))} <br /> -->
          解卦：
          <div class="note-box light-green lighten-4">
            {@html marked(buildHtmlExplanation(record.explanation))}
          </div>
        {/if}
        {#if record.comment == null}
          笔记： "" <br />
        {:else}
          <!-- 笔记： {record.comment.content} <br /> -->
          <!-- 笔记： {@html marked(guaCommentsToString(record.comment))} <br /> -->
          <!-- Note: record.comment is an Array and will be passed to guaCommentsToString in helpers 
        to decrypt content and create the long HTML string. -->
          笔记：
          <div class="note-box blue lighten-5">
            {@html guaCommentsToString(record.comment)}
          </div>
        {/if}
        <br />
        <button class={btn_style_blue_d2} on:click={handleShowSummary}
          >关闭摘要</button
        >
        <button class={btn_style_red_d2 + " right"} on:click={deleteGuaRecord}
          >移除卦例</button
        >
      </div>
    </div>
  </div>

  <!-- Gua Detail Research Section Begin -->
  <div class="details " style="display:{showDetails ? 'block' : 'none'}">
    <div class="card indigo lighten-5">
      <div class="card-body ">
        <div class="gua-header">
          <h4>
            {guaName} 细究
            <div class="btn-group right">
              <!-- {#if sectionName != "qi"}
              <button class={btn_style_blue_d2} on:click={showYiOptions}
                >回易经选项</button
              >
            {/if} -->
              <button
                class={btn_style_blue_d2}
                on:click={() => showView("summary")}>回到摘要</button
              >
              <button
                class={btn_style_purple_d2}
                on:click={() => showAddCommentField()}>笔记</button
              >
              <button
                class={btn_style_light_blue_a3}
                on:click={() => showAddExlpainField()}>解卦</button
              >
            </div>
          </h4>

          <h5>问：{AesCtr.decrypt(record.question, xiyiSalt, 256)}</h5>
          <div
            class="comment-input"
            style="display:{showInputField ? 'block' : 'none'}"
          >
            <div class="markdown-text">
              <label for="markdown">New Comment</label>
              <textarea
                class="white"
                bind:value={newComment}
                placeholder="Enter text here"
              />
            </div>
            <div class="btn-row">
              <button class={btn_style_blue_d2} on:click={addComment}
                >加入笔记</button
              >
              <button class={btn_style_red_d2} on:click={cancelComment}
                >取消</button
              >
            </div>
            <!-- Convert the markdown to HTML and display it -->
            <hr />
            <div class="preview">{@html marked(newComment)}</div>
          </div>

          <div
            class="explanation-input"
            style="display:{showExplainField ? 'block' : 'none'}"
          >
            <div class="markdown-text">
              <label for="markdown">试解卦</label>
              <textarea class="white" bind:value={newExplanation} />
            </div>
            <button class={btn_style_blue_d2} on:click={addExplanation}
              >输入解卦</button
            >
            <button class={btn_style_red_d2} on:click={cancelExplanation}
              >取消</button
            >

            <!-- Convert the markdown to HTML and display it -->

            <div class="preview">{@html marked(newComment)}</div>
          </div>
        </div>
        <div class="gua-text green lighten-5">
          <ShowGuaText numStr={reverseString(record.guaNumbers)} {gua_code} />
        </div>
        <div class="yao-level ">
          <ShowCompleteYaoInfo
            numStr={record.guaNumbers}
            {gua_code}
            incomingYaoColor={yaoColor}
            {sectionName}
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Gua Detail Research Section End -->
{/if}

<style>
  .member {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  .guapic {
    display: grid;
    grid-template-columns: 1fr 6fr;
  }
  .guapic:hover {
    cursor: pointer;
  }
  .gua-title {
    padding-bottom: 5px;
  }
  .guacard {
    display: grid;
    margin-right: 10px;
  }
  .guabox {
    margin: auto;
    min-width: 80px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .record-control {
    float: right;
  }
  .gua-results {
    margin: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .btn-single {
    margin-bottom: 8px;
    margin-right: 10px;
  }
  textarea,
  .preview {
    box-sizing: border-box;
    display: block;
    width: 100%;
  }

  textarea {
    font-family: monospace, Roboto;
    height: 80px;
    border: none;
    margin: 0;
    padding: 1rem;
  }

  .preview {
    height: 75%;
    padding: 2rem;
    border-top: solid 2px #888;
  }
  .checkbox-spacing {
    padding-left: 25px;
    padding-right: 25px;
  }
  .btn-row {
    margin-top: 10px;
  }
  .note-box {
    padding: 0px 10px;
    border: solid #90caf9 1px;
    border-radius: 8px;
  }
</style>
